import styled from "styled-components";
import {
  Typography as MuiTypography,
  Box as MuiBox,
} from "@mui/material";

export {
  Wrap,
  Container,
  Box,
  SecondBox,
} from "../Templates/styles";

export const SecondContainer = styled(MuiBox)`
  &.MuiBox-root {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
  }
`;

export const ThirdBox = styled(MuiBox)`
  &.MuiBox-root {
    height: 20px;
    display: flex;
    align-items: center;
    gap: 2px;
  }
`;

export const Typography = styled(MuiTypography)`
  &.MuiTypography-root {
    flex-direction: column;
    justify-content: flex-start;
    font-size: 14px;
    text-overflow: ellipsis;
  }
`;
